import { GridColDef } from "@mui/x-data-grid-pro";
import { TablePage } from "components/alove/TablePage";
import { getAttributes, publishAttributes, saveAttributeOrder } from "utils/attributesUtil";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Attribute, AttributePolicy } from "models/profile/Attribute";
import { useNavigate } from "react-router-dom";
import { addAlert, useMaterialUIController } from "context";
import { capitalize } from "@mui/material";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useState } from "react";
import { groupBy } from "utils/globalsUtils";
export const AttributesList = () => {
  const [controller, dispatch] = useMaterialUIController();
  const [reorderMode, setReorderMode] = useState(false);
  const [categoryReorderMode, setCategoryReorderMode] = useState(false);
  const [rows, setRows] = useState<Attribute[]>([]);
  const [categoryRows, setCategoryRows] = useState<Attribute[]>([]);
  

  const navigate = useNavigate();
  const columns: GridColDef<Attribute>[] = [
    {
      headerName: "Name",
      field: "txt",
      valueGetter: (v,row) => v || row.name,
      flex: 1,
    },
    {
      headerName: "Questions",
      field: "questions",
      renderCell: (params) => {
        return params.row.questions?.map((q: any) => q.id).join(", ");
      },
      flex: 1,
    },
    {
      headerName: "Category",
      field: "attributeCategory",
      flex: 1,
    }
  ];
  const loadNext = async (filters: any, page: number) => {
    if (!filters["brand"]) return [];

    const response = await getAttributes();
    let sortedResponse = response.sort((a, b) => a.ordinal - b.ordinal);
    if (reorderMode) {
      sortedResponse = sortedResponse
      .filter(r => r.defaultPolicy != AttributePolicy.Hidden)
      .filter(r => r.attributeCategory)
      setRows(sortedResponse);
    }
    if (categoryReorderMode) {
      // Group by category and take only the first item from each category
      const groupedByCategory = groupBy(sortedResponse, x => x.attributeCategory);
      const categoryRepresentatives = (Object.values(groupedByCategory) as Attribute[][]).map((group: Attribute[]) => group[0]);
      setCategoryRows(categoryRepresentatives);
      return categoryRepresentatives;
    }
    return sortedResponse;
  };

  const onRowOrderChange = (params: any) => {
    
    // Create a copy of the current rows and reorder them
    let updatedRows = [...rows];
    const [movedRow] = updatedRows.splice(params.oldIndex, 1);
    updatedRows.splice(params.targetIndex, 0, movedRow);

    
    setRows(updatedRows);
    
 };

  const onCategoryRowOrderChange = (params: any) => {
    // Create a copy of the current category rows and reorder them
    let updatedCategoryRows = [...categoryRows];
    const [movedRow] = updatedCategoryRows.splice(params.oldIndex, 1);
    updatedCategoryRows.splice(params.targetIndex, 0, movedRow);
    
    setCategoryRows(updatedCategoryRows);
  };

  const saveOrder = () => {
    if (reorderMode) {
      console.log(rows[0]);
      const attributeIds = rows.map(row => row.id.toString());
      saveAttributeOrder(attributeIds)
        .then(() => {
          addAlert(dispatch, "Attribute order saved successfully");
        })
    }
    setReorderMode(!reorderMode);
  }

  const saveCategoryOrder = () => {
    if (categoryReorderMode) {
      // Get all attributes and group them by category
      getAttributes().then((allAttributes) => {
        const groupedByCategory = groupBy(allAttributes, x => x.attributeCategory);
        
        // Create new order based on category representatives order
        let newOrderedAttributes: Attribute[] = [];
        
        categoryRows.forEach((categoryRep) => {
          const categoryName = categoryRep.attributeCategory;
          const categoryItems = groupedByCategory[categoryName] || [];
          
          // Preserve inner ordinal within each category
          const sortedCategoryItems = categoryItems.sort((a, b) => a.ordinal - b.ordinal);
          newOrderedAttributes.push(...sortedCategoryItems);
        });
        
        const attributeIds = newOrderedAttributes.map(row => row.id.toString());
        saveAttributeOrder(attributeIds)
          .then(() => {
            addAlert(dispatch, "Category order saved successfully");
          })
      });
    }
    setCategoryReorderMode(!categoryReorderMode);
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <TablePage
        title="Attributes"
        actions={{
          saveActions: [
            ...(reorderMode || categoryReorderMode ? [] : [{
              label: "Publish",
              variant: "contained" as const,
              onClick: () =>
                publishAttributes().then(() => addAlert(dispatch, "Attributes published")),
            }]),
            ...(categoryReorderMode ? [] : [{
              label: reorderMode ? "Save Order" : "Reorder",
              variant: "contained" as const,
              onClick: () => saveOrder(),
            }]),
            ...(reorderMode ? [] : [{
              label: categoryReorderMode ? "Update Category Order" : "Reorder Categories",
              variant: "contained" as const,
              onClick: () => saveCategoryOrder(),
            }]),
          ],
        }}
        refresh={reorderMode || categoryReorderMode}
        table={{
          columns,
          loadNext,
          onRowOrderChange: reorderMode ? onRowOrderChange : categoryReorderMode ? onCategoryRowOrderChange : undefined,
          lineClick: (row) => isNaN(row.id) ? null :  navigate(`/attributes/${row.id}`),
          getTreeDataPath: reorderMode ? (row) => [row.id.toString()] : categoryReorderMode ? (row) => [row.id.toString()] : (row) => [
            (capitalize(row.attributeGroup || "No group")),
            capitalize(row.attributeCategory || "No category"),
              `#${row.id}`],
        }}
        rerenderKey={JSON.stringify(reorderMode ? rows : categoryReorderMode ? categoryRows : [])}
      />
    </DashboardLayout>
  );
};
